/* eslint-disable */
import * as Yup from 'yup';
import { useState, useEffect, useRef } from 'react';
// material
import {
    Container, Card,
    Autocomplete
} from '@material-ui/core';
import { useFormik, Form, FormikProvider } from 'formik';
import { Stack, TextField, IconButton, Button, Box, Grid, Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Checkbox, Chip } from '@material-ui/core';
import MenuItem from '@material-ui/core/MenuItem';
import { useNavigate } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import { AESEncryptionParam } from '../../../../helpers/AesEncrypt';
import CommonPageHeader from '../../../CommonPageModules/CommonPageHeader';
import Page from '../../../Page';
import SearchNotFound from '../../../SearchNotFound';
import services from '../Services';
import permissionAuth from 'src/utils/permissionAuth';
import TokenDecoder from 'src/helpers/TokenDecoder';
import { trackPromise } from 'react-promise-tracker';
import { LoadingComponent } from 'src/pages/pageLoader';
import TableFooter from '@mui/material/TableFooter';
import TablePagination from '@mui/material/TablePagination';
import FirstPageIcon from '@mui/icons-material/FirstPage';
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import LastPageIcon from '@mui/icons-material/LastPage';
import PropTypes, { func } from 'prop-types'
import { useTheme } from '@mui/material/styles'
import { truncate } from 'lodash';

function TablePaginationActions(props) {
    const theme = useTheme();
    const { count, page, rowsPerPage, onPageChange } = props;

    const handleFirstPageButtonClick = (event) => {
        onPageChange(event, 0);
    };

    const handleBackButtonClick = (event) => {
        onPageChange(event, page - 1);
    };

    const handleNextButtonClick = (event) => {
        onPageChange(event, page + 1);
    };

    const handleLastPageButtonClick = (event) => {
        onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
    };

    return (
        <Box sx={{ flexShrink: 0, ml: 2.5 }}>
            <IconButton
                onClick={handleFirstPageButtonClick}
                disabled={page === 0}
                aria-label="first page"
            >
                {theme.direction === 'rtl' ? <LastPageIcon /> : <FirstPageIcon />}
            </IconButton>
            <IconButton
                onClick={handleBackButtonClick}
                disabled={page === 0}
                aria-label="previous page"
            >
                {theme.direction === 'rtl' ? <KeyboardArrowRight /> : <KeyboardArrowLeft />}
            </IconButton>
            <IconButton
                onClick={handleNextButtonClick}
                disabled={page >= Math.ceil(count / rowsPerPage) - 1}
                aria-label="next page"
            >
                {theme.direction === 'rtl' ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
            </IconButton>
            <IconButton
                onClick={handleLastPageButtonClick}
                disabled={page >= Math.ceil(count / rowsPerPage) - 1}
                aria-label="last page"
            >
                {theme.direction === 'rtl' ? <FirstPageIcon /> : <LastPageIcon />}
            </IconButton>
        </Box>
    );
}

TablePaginationActions.propTypes = {
    count: PropTypes.number.isRequired,
    onPageChange: PropTypes.func.isRequired,
    page: PropTypes.number.isRequired,
    rowsPerPage: PropTypes.number.isRequired,
};

export default function CustomerTypeMappingListing() {
    const screenCode = 'CUSTOMERTYPEMAPPING';
    let encrypted = "";
    const navigate = useNavigate();

    const STORAGE_KEYS = {
        filters: 'customerTypeMappingListingFilters',
        page: 'customerTypeMappingListingPage',
        rowsPerPage: 'customerTypeMappingListingRowsPerPage'
    };

    const isRestoringRef = useRef(false);
    const restoredFiltersRef = useRef(null);
    const latestListingStateRef = useRef({ lastSearchValues: null, page: 0, rowsPerPage: 5 });
    const [productcatogery, setProductcatogery] = useState([]);
    const [selectedProducts, setSelectedProducts] = useState([]);
    const [isFarmerClear, setIsFarmerClear] = useState(false);
    const [selectedProductCategory, setSelectedProductCategory] = useState(0);
    const [IsClear, setIsClear] = useState(false);
    const [autocompleteKey, setAutocompleteKey] = useState(0);
    const [product, setProduct] = useState([]);
    const [selectedCategory, setSelectedCategory] = useState(null);
    const [groupList, setGroupList] = useState([]);
    const [tableData, setTableData] = useState([]);
    const [lastSearchValues, setLastSearchValues] = useState(null);
    const [formData, setFormData] = useState({
        groupID: "0",
        productCategoryID: '',
        productID: '',
        orderTypeID: ''
    });
    const [permissionList, setPermissions] = useState({
        isGroupFilterEnabled: false
    });
    const GroupSearchSchema = Yup.object().shape({
        groupID: Yup.number().min(1, 'Please select a Group').required('Group Required'),
        productCategoryID: Yup.number().min(1, 'Please Select Product Category').required('Product Category Required'),
        productID: Yup.string()
            .required('Product Required')
            .test('has-product', 'Please Select Product', (value) => {
                if (value === null || value === undefined) return false;
                const trimmed = String(value).trim();
                if (trimmed.length === 0) return false;
                const ids = trimmed.split(',').map((x) => x.trim()).filter(Boolean);
                return ids.length > 0;
            }),
        orderTypeID: Yup.number().nullable()
    });

    const formik = useFormik({
        initialValues: {
            groupID: formData.groupID,
            productCategoryID: formData.productCategoryID,
            productID: formData.productID,
            orderTypeID: formData.orderTypeID
        },
        validationSchema: GroupSearchSchema,
        onSubmit: (values) => {
            setLastSearchValues(values);
            trackPromise(GetAllCustomerTypeMappingDetails(values));

        },
    });

    const { errors, setValues, touched, handleSubmit, isSubmitting, getFieldProps, values } = formik;

    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(5);
    const [orderTypeList, setOrderTypeList] = useState([]);
    const [deleteConfirm, setDeleteConfirm] = useState({
        open: false,
        mappingId: 0
    });

    useEffect(() => {
        latestListingStateRef.current = { lastSearchValues, page, rowsPerPage };
    }, [lastSearchValues, page, rowsPerPage]);

    useEffect(() => {
        return () => {
            const { lastSearchValues: latestFilters, page: latestPage, rowsPerPage: latestRowsPerPage } = latestListingStateRef.current;
            if (latestFilters === null) {
                return;
            }
            sessionStorage.setItem(STORAGE_KEYS.filters, JSON.stringify(latestFilters));
            sessionStorage.setItem(STORAGE_KEYS.page, JSON.stringify(latestPage));
            sessionStorage.setItem(STORAGE_KEYS.rowsPerPage, JSON.stringify(latestRowsPerPage));
        };
    }, []);

    const emptyRows =
        page > 0 ? Math.max(0, (1 + page) * rowsPerPage - tableData.length) : 0;

    const formatIsoDateOnly = (value) => {
        if (value === null || value === undefined) return "-";
        if (typeof value === 'string' && value.trim().startsWith('0001-01-01')) return "-";
        const d = new Date(value);
        if (Number.isNaN(d.getTime())) return "-";
        return d.toISOString().split('T')[0];
    };

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    useEffect(() => {
        const safeJsonParse = (value) => {
            try {
                return value ? JSON.parse(value) : null;
            } catch {
                return null;
            }
        };

        const storedFilters = safeJsonParse(sessionStorage.getItem(STORAGE_KEYS.filters));
        const storedPage = safeJsonParse(sessionStorage.getItem(STORAGE_KEYS.page));
        const storedRowsPerPage = safeJsonParse(sessionStorage.getItem(STORAGE_KEYS.rowsPerPage));

        trackPromise(loadPermissions(storedFilters, storedPage, storedRowsPerPage));

        sessionStorage.removeItem(STORAGE_KEYS.filters);
        sessionStorage.removeItem(STORAGE_KEYS.page);
        sessionStorage.removeItem(STORAGE_KEYS.rowsPerPage);
    }, []);

    useEffect(() => {
        loadGroups();
        trackPromise(loadProductCategories());
    }, []);

    useEffect(() => {
        if (isRestoringRef.current) {
            return;
        }
        setProduct([]);
        setSelectedProducts([]);
        setSelectedCategory(null);
        setTableData([]);
        formik.setFieldValue('productID', '');
        formik.setFieldValue('productCategoryID', '');
        setIsClear(!IsClear);
        setAutocompleteKey((prevKey) => prevKey + 1);
        setValues({
            ...values,
            productCategoryID: '',
            productID: ''
        });
        setIsFarmerClear(!isFarmerClear);
        setTableData([]);
        setSelectedProductCategory(0)
    }, [formik.values.groupID]);

    useEffect(() => {
        if (isRestoringRef.current) {
            return;
        }
        formik.setFieldValue('productID', '');
        setAutocompleteKey((prevKey) => prevKey + 1);
        setValues({
            ...values,
            productCategoryID: selectedProductCategory,
            productID: ''
        });
        setIsFarmerClear(!isFarmerClear);
        setTableData([]);
        setSelectedProducts([]);
        trackPromise(loadProductsByCategory(formik.values.productCategoryID));
    }, [formik.values.productCategoryID]);

    useEffect(() => {
        trackPromise(loadCustomerOrderTypes());
    }, []);

    function persistListingState() {
        if (lastSearchValues === null) {
            return;
        }

        sessionStorage.setItem(STORAGE_KEYS.filters, JSON.stringify(lastSearchValues));
        sessionStorage.setItem(STORAGE_KEYS.page, JSON.stringify(page));
        sessionStorage.setItem(STORAGE_KEYS.rowsPerPage, JSON.stringify(rowsPerPage));
    }

    async function loadPermissions(storedFilters, storedPage, storedRowsPerPage) {
        var permissions = await permissionAuth.getPermissionsByScreen(screenCode);
        var isAuthorized = permissions.find(p => p.permissionCode == 'VIEWCUSTOMERTYPEMAPPING');

        if (isAuthorized === undefined) {
            navigate('/404');
        }
        var isGroupFilterEnabled = permissions.find((p) => p.permissionCode == 'GROUPDROPDOWN');

        setPermissions({
            ...permissionList,
            isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
        });

        const isInitialLoading = storedFilters === null;
        if (isInitialLoading) {
            setValues({
                ...values,
                groupID: parseInt(TokenDecoder.getGroupFactoryToken().group),
            });
        } else {
            isRestoringRef.current = true;

            const restoredOrderTypeIDFromNew = parseInt(storedFilters?.orderTypeID, 10);
            const restoredOrderTypeIDsRaw = storedFilters?.orderTypeIDs ?? [];
            const restoredOrderTypeIDFromOld = Array.isArray(restoredOrderTypeIDsRaw)
                ? parseInt(restoredOrderTypeIDsRaw?.[0], 10)
                : parseInt(restoredOrderTypeIDsRaw, 10);

            const restoredOrderTypeID = (!Number.isNaN(restoredOrderTypeIDFromNew) && restoredOrderTypeIDFromNew > 0)
                ? restoredOrderTypeIDFromNew
                : (!Number.isNaN(restoredOrderTypeIDFromOld) && restoredOrderTypeIDFromOld > 0)
                    ? restoredOrderTypeIDFromOld
                    : 0;

            const restoredModel = {
                groupID: parseInt(storedFilters.groupID),
                productCategoryID: parseInt(storedFilters.productCategoryID),
                productID: storedFilters?.productID !== undefined && storedFilters?.productID !== null
                    ? String(storedFilters.productID)
                    : '',
                orderTypeID: restoredOrderTypeID
            };

            restoredFiltersRef.current = restoredModel;

            setValues({
                ...values,
                ...restoredModel
            });

            setLastSearchValues(restoredModel);

            if (storedRowsPerPage !== null && !Number.isNaN(parseInt(storedRowsPerPage))) {
                setRowsPerPage(parseInt(storedRowsPerPage));
            }
            if (storedPage !== null && !Number.isNaN(parseInt(storedPage))) {
                setPage(parseInt(storedPage));
            }

            await GetAllCustomerTypeMappingDetails(restoredModel, false);

            if (storedPage !== null && !Number.isNaN(parseInt(storedPage))) {
                setPage(parseInt(storedPage));
            }

            isRestoringRef.current = false;
        }
    }

    useEffect(() => {
        if (restoredFiltersRef.current === null) {
            return;
        }

        if (productcatogery === null || productcatogery.length === 0) {
            return;
        }

        const restoredCategoryId = restoredFiltersRef.current.productCategoryID;
        const categoryOption = productcatogery.find(
            (x) => parseInt(x.productCategoryID) === parseInt(restoredCategoryId)
        );

        if (categoryOption) {
            setSelectedCategory(categoryOption);
            setSelectedProductCategory(categoryOption.productCategoryID);
            trackPromise(loadProductsByCategory(categoryOption.productCategoryID));
        }
    }, [productcatogery]);

    useEffect(() => {
        if (restoredFiltersRef.current === null) {
            return;
        }

        if (product === null || product.length === 0) {
            return;
        }

        const restoredProductIds = String(restoredFiltersRef.current.productID ?? '')
            .split(',')
            .map((x) => parseInt(x, 10))
            .filter((x) => !Number.isNaN(x) && x > 0);

        if (restoredProductIds.length === 0) {
            return;
        }

        const selected = product.filter((x) =>
            restoredProductIds.includes(parseInt(x.productID, 10))
        );

        if (selected.length > 0) {
            setSelectedProducts(selected);
        }
    }, [product]);

    async function loadGroups() {
        var resNew = await services.GetAllGroups();
        if (resNew != null) {
            setGroupList(resNew);
        }
    }

    async function GetAllCustomerTypeMappingDetails(filterValues, resetPage = true) {
        var res = await services.GetAllCustomerTypeMappingDetails(filterValues ?? values);
        if (res != null) {
            setTableData(res);
        }
        if (resetPage) {
            setPage(0);
        }
    }

    async function handleDeleteCustomerTypeMapping(customerTypeMappingID) {
        if (customerTypeMappingID === undefined || customerTypeMappingID === null || customerTypeMappingID === '') {
            toast.error('Selected record has no mapping ID');
            return;
        }

        const res = await services.DeleteCustomerTypeMapping(customerTypeMappingID);
        if (res?.statusCode === 'Success') {
            toast.success(res?.message ?? 'Customer Type Mapping deleted successfully');
            await GetAllCustomerTypeMappingDetails(values);
        } else {
            toast.error(res?.message ?? 'Error occured in Customer Type Mapping delete');
        }
    }

    const closeDeleteConfirm = () => setDeleteConfirm({ open: false, mappingId: 0 });

    const confirmDeleteCustomerTypeMapping = async () => {
        const id = parseInt(deleteConfirm.mappingId);
        if (!id || Number.isNaN(id) || id < 1) {
            toast.error('Selected record has no mapping ID');
            closeDeleteConfirm();
            return;
        }

        try {
            await handleDeleteCustomerTypeMapping(id);
        } finally {
            closeDeleteConfirm();
        }
    };

    function resetFilters() {
        const preservedGroupID = formik.values.groupID;

        sessionStorage.removeItem(STORAGE_KEYS.filters);
        sessionStorage.removeItem(STORAGE_KEYS.page);
        sessionStorage.removeItem(STORAGE_KEYS.rowsPerPage);
        setLastSearchValues(null);

        setSelectedCategory(null);
        setSelectedProducts([]);
        setSelectedProductCategory(0);
        setProduct([]);

        formik.resetForm({
            values: {
                groupID: preservedGroupID,
                productCategoryID: '',
                productID: '',
                orderTypeID: 0
            }
        });

        setIsClear(!IsClear);
        setAutocompleteKey((prevKey) => prevKey + 1);
        setTableData([]);
        setPage(0);

    }

    async function goToAddEdit(datas) {
        if (datas === undefined || datas === null || datas === '') {
            toast.error('Selected record has no mapping ID');
            return;
        }
        persistListingState();
        encrypted = AESEncryptionParam(String(datas));
        navigate('/dashboard/CustomerTypeMapping/addedit/' + encrypted);
    }

    async function loadProductCategories() {
        var result = await services.GetProductCategoties()
        result.forEach(x => {
            x.productCategoryName = x.productCategoryName == null || x.productCategoryName == "" ? x.categoryCode : x.productCategoryName
        })
        setProductcatogery(result);

    }

    async function loadProductsByCategory(categoryId) {
        const catId = parseInt(categoryId ?? formik.values.productCategoryID);
        if (!catId || catId < 1) {
            setProduct([]);
            return;
        }
        var res = await services.GetProductDetailsByProductcatogeryID(catId);
        setProduct(res != null ? res : []);
    }

    function handleSearchDropdownChangePrefferdName(data, e) {
        if (data === undefined || data === null) {
            setSelectedCategory(data);
            setValues({
                ...formik.values,
                productCategoryID: '0'
            });
            setSelectedProducts([]);
            return;
        } else {
            setSelectedCategory(data);
            var nameP = 'productCategoryID';
            var valueP = data.productCategoryID;
            setValues({
                ...formik.values,
                productCategoryID: valueP
            });
            setSelectedProductCategory(valueP);
            setSelectedProducts([]);
        }
    }

    function handleSearchCrop(data, e) {
        const raw = Array.isArray(data) ? data : [];
        let selected;
        if (raw.some((x) => x?.productID === -1)) {
            selected = selectedProducts.length === product.length ? [] : [...product];
        } else {
            selected = raw;
        }
        const productIDsCsv = selected
            .map((x) => String(x?.productID ?? '').trim())
            .filter((x) => x !== '' && x !== '0' && x !== '-1')
            .join(',');

        formik.setFieldTouched('productID', true, false);
        formik.setFieldValue('productID', productIDsCsv);
        setSelectedProducts(selected);
    }

    const getSelectedProductsSummary = (selected) => {
        if (!Array.isArray(selected) || selected.length === 0) {
            return '';
        }

        const firstName = selected[0]?.productName ?? '';
        const remaining = selected.length - 1;
        if (remaining <= 0) {
            return firstName;
        }
        return `${firstName} +${remaining} more`;
    };
    async function loadCustomerOrderTypes() {
            try {
                var res = await services.GetCustomerOrderTypes();
                if (res != null) {
                    setOrderTypeList(res);
                }
            } catch (error) {
                toast.error('Failed to load Customer Types');
            }
        }

    const filterOptions = (options, { inputValue }) => {
        const trimmedInput = inputValue.trim().toLowerCase();

        const filteredOptions = options.filter(option =>
            (option.productCategoryName && option.productCategoryName.toLowerCase().includes(trimmedInput))
        ).filter(option => option.productCategoryName !== null);

        const exactMatchOptions = [];
        const nonExactMatchOptions = [];
        filteredOptions.forEach(option => {
            if (
                option.productCategoryName.toLowerCase() === trimmedInput
            ) {
                exactMatchOptions.push(option);
            } else {
                nonExactMatchOptions.push(option);
            }
        });
        return exactMatchOptions.length > 0 ? exactMatchOptions : nonExactMatchOptions;
    };

    return (
        <>
            <LoadingComponent />
            <Page title="SKU-Customer Type Mapping |  FAPS">
                <Container>
                    <CommonPageHeader
                        path={"/dashboard/CustomerTypeMapping/addedit/" + AESEncryptionParam("0")}
                        btname="Add"
                        pageName="SKU-Customer Type Mapping"
                    />
                    <FormikProvider value={formik}>
                        <ToastContainer
                            position="bottom-right"
                            pauseOnHover
                        />
                        <Dialog
                            open={deleteConfirm.open}
                            onClose={closeDeleteConfirm}
                            aria-labelledby="customer-type-mapping-delete-dialog-title"
                        >
                            <DialogTitle id="customer-type-mapping-delete-dialog-title">
                                Delete Customer Type Mapping
                            </DialogTitle>
                            <DialogContent>
                                <DialogContentText>
                                    Are you sure you want to delete this Customer Type Mapping?
                                </DialogContentText>
                            </DialogContent>
                            <DialogActions>
                                <Button onClick={closeDeleteConfirm} color="inherit">
                                    Cancel
                                </Button>
                                <Button onClick={() => trackPromise(confirmDeleteCustomerTypeMapping())} color="error" variant="contained">
                                    OK
                                </Button>
                            </DialogActions>
                        </Dialog>
                        <Form autoComplete="off" noValidate onSubmit={handleSubmit}>
                            <Stack spacing={2}>
                                <Stack spacing={2}>
                                    <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                                        <Grid item md={4} xs={12}>
                                            <TextField
                                                select
                                                fullWidth
                                                size="small"
                                                label="Group *"
                                                value={formik.values.groupID}
                                                onChange={formik.handleChange}
                                                {...getFieldProps('groupID')}
                                                error={Boolean(touched.groupID && errors.groupID)}
                                                helperText={touched.groupID && errors.groupID}
                                                InputProps={{
                                                    readOnly: !permissionList.isGroupFilterEnabled
                                                }}
                                            >
                                                <MenuItem key={0} value={0}>Select Group</MenuItem>
                                                {groupList.map((option) => (
                                                    <MenuItem key={option.groupID} value={option.groupID}>
                                                        {option.groupName}
                                                    </MenuItem>
                                                ))}
                                            </TextField>
                                        </Grid>
                                        <Grid item md={4} xs={12}>
                                            <Autocomplete
                                                fullWidth
                                                key={IsClear}
                                                id="productCategoryID"
                                                options={productcatogery}
                                                value={selectedCategory}
                                                filterOptions={filterOptions}
                                                isOptionEqualToValue={(option, value) =>
                                                    parseInt(option.productCategoryID) === parseInt(value.productCategoryID)
                                                }
                                                getOptionLabel={(option) => option.productCategoryName || ''}
                                                onChange={(e, value) => {
                                                    handleSearchDropdownChangePrefferdName(value, e);
                                                    formik.setFieldValue('productID', '');
                                                }}
                                                renderInput={(params) =>
                                                    <TextField {...params}
                                                        variant="outlined"
                                                        name="productCategoryID"
                                                        label="Product Category *"
                                                        size="small"
                                                        fullWidth
                                                        helperText={touched.productCategoryID && errors.productCategoryID}
                                                        error={Boolean(touched.productCategoryID && errors.productCategoryID)}
                                                    />
                                                }
                                            />
                                        </Grid>
                                        <Grid item md={4} xs={12}>
                                            <Autocomplete
                                                multiple
                                                disableCloseOnSelect
                                                limitTags={1}
                                                fullWidth
                                                key={autocompleteKey}
                                                id="productID"
                                                options={[{ productID: -1, productName: 'Select All' }, ...product]}
                                                value={selectedProducts}
                                                isOptionEqualToValue={(option, value) =>
                                                    parseInt(option.productID) === parseInt(value.productID)
                                                }
                                                getOptionLabel={(option) => option.productName || ''}
                                                onChange={(e, value) => handleSearchCrop(value, e)}
                                                renderOption={(props, option, { selected }) => {
                                                    if (option.productID === -1) {
                                                        const allSelected = selectedProducts.length === product.length;
                                                        return (
                                                            <li {...props}>
                                                                <Checkbox
                                                                    style={{ marginRight: 8 }}
                                                                    checked={allSelected}
                                                                    indeterminate={selectedProducts.length > 0 && !allSelected}
                                                                />
                                                                Select All
                                                            </li>
                                                        );
                                                    }
                                                    return (
                                                        <li {...props}>
                                                            <Checkbox style={{ marginRight: 8 }} checked={selected} />
                                                            {option.productName}
                                                        </li>
                                                    );
                                                }}
                                                renderTags={(value) => {
                                                    const label = getSelectedProductsSummary(value);
                                                    return label ? (
                                                        <Chip
                                                            key="selected-products-summary"
                                                            label={label}
                                                            size="small"
                                                            style={{ margin: 0 }}
                                                        />
                                                    ) : null;
                                                }}
                                                renderInput={(params) => (
                                                    <TextField
                                                        {...params}
                                                        variant="outlined"
                                                        name="productID"
                                                        label="Product *"
                                                        size="small"
                                                        fullWidth
                                                        helperText={touched.productID && errors.productID}
                                                        error={Boolean(touched.productID && errors.productID)}
                                                        InputProps={{
                                                            ...params.InputProps,
                                                            style: {
                                                                ...params.InputProps?.style,
                                                                flexWrap: 'nowrap',
                                                                minHeight: 40,
                                                                paddingTop: 0,
                                                                paddingBottom: 0,
                                                                alignItems: 'center'
                                                            }
                                                        }}
                                                    />
                                                )}
                                            />
                                        </Grid>
                                    </Stack>
                                 <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                                    <Grid item md={4} xs={12}>
                                        <TextField
                                            select
                                            fullWidth
                                            size="small"
                                            label="Customer Type"
                                            value={formik.values.orderTypeID}
                                            onChange={formik.handleChange}
                                            {...getFieldProps('orderTypeID')}
                                            error={Boolean(touched.orderTypeID && errors.orderTypeID)}
                                            helperText={touched.orderTypeID && errors.orderTypeID}
                                        >
                                            <MenuItem key={0} value={0}>Select Customer Type</MenuItem>
                                            {orderTypeList.map((option) => (
                                                <MenuItem key={option.orderTypeID} value={option.orderTypeID}>
                                                    {option.orderTypeName}
                                                </MenuItem>
                                            ))}
                                        </TextField>
                                    </Grid>
                                    </Stack>

                                    <Grid >
                                        <Stack direction={{ xs: 'column', sm: 'row' }} justifyContent="right" spacing={2}>
                                            <Button
                                                type="button"
                                                color='error'
                                                variant="outlined"
                                                onClick={() => resetFilters()}
                                            > Clear</Button>
                                            <Button
                                                type="submit"
                                                color='secondary'
                                                variant="outlined"
                                            >Search</Button>
                                        </Stack>
                                    </Grid>
                                </Stack>
                            </Stack>
                        </Form>
                    </FormikProvider>
                    <br />
                    {tableData.length == 0 ?
                        <SearchNotFound searchQuery="Customer type" />
                        :
                        <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                            <Card style={{ justifyContent: 'center', width: '100%' }}>
                                <TableContainer component={Paper} >
                                    <Table aria-label="customer-type-mapping-table" size="small">
                                        <TableHead>
                                            <TableRow>
                                                <TableCell align="left" style={{ fontWeight: 600 }}>Group Name</TableCell>
                                                <TableCell align="left" style={{ fontWeight: 600 }}>Product Category</TableCell>
                                                <TableCell align="left" style={{ fontWeight: 600 }}>Product Name</TableCell>
                                                <TableCell align="left" style={{ fontWeight: 600 }}>Order Type</TableCell>
                                                <TableCell align="center" style={{ fontWeight: 600, width: 120 }}>Action</TableCell>
                                            </TableRow>
                                        </TableHead>

                                        <TableBody>
                                            {(rowsPerPage > 0
                                                ? tableData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                                : tableData
                                            ).map((row) => (
                                                <TableRow key={row.customerTypeMappingID} hover>
                                                    <TableCell align="left">
                                                        {row.groupName}
                                                    </TableCell>
                                                    <TableCell align="left">
                                                        {row.productCategoryName}
                                                    </TableCell>
                                                    <TableCell align="left">
                                                        {row.productName}
                                                    </TableCell>
                                                    <TableCell align="left">
                                                        {row.orderTypeName}
                                                    </TableCell>

                                                    <TableCell align="center">
                                                        <Stack direction="row" spacing={1} justifyContent="center" alignItems="center">
                                                            <IconButton aria-label="edit" onClick={() => goToAddEdit(row.customerTypeMappingID)} size="small">
                                                                <EditIcon />
                                                            </IconButton>
                                                            <IconButton
                                                                aria-label="delete"
                                                                onClick={() => setDeleteConfirm({ open: true, mappingId: row.customerTypeMappingID })}
                                                                size="small"
                                                            >
                                                                <DeleteIcon color="error" />
                                                            </IconButton>
                                                        </Stack>
                                                    </TableCell>
                                                </TableRow>
                                            ))}
                                            {emptyRows > 0 && (
                                                <TableRow style={{ height: 53 * emptyRows }}>
                                                    <TableCell colSpan={5} />
                                                </TableRow>
                                            )}
                                        </TableBody>
                                        <TableFooter>
                                            <TableRow>
                                                <TablePagination
                                                    rowsPerPageOptions={[5, 10, 25, { label: 'All', value: -1 }]}
                                                    colSpan={5}
                                                    count={tableData.length}
                                                    rowsPerPage={rowsPerPage}
                                                    page={page}
                                                    SelectProps={{
                                                        inputProps: {
                                                            'aria-label': 'rows per page',
                                                        },
                                                        native: true,
                                                    }}
                                                    onPageChange={handleChangePage}
                                                    onRowsPerPageChange={handleChangeRowsPerPage}
                                                    ActionsComponent={TablePaginationActions}
                                                />
                                            </TableRow>
                                        </TableFooter>
                                    </Table>
                                </TableContainer>
                            </Card>
                        </Stack>
                    }
                </Container>
            </Page>
        </>
    );
}